import gql from 'graphql-tag';

export const getMyMessagingTokenQuery = gql(`
  query getMyMessagingToken {
    me {
      user {
        _id
        messagingToken
        name
      }
    }
  }
`);
